import React from "react";
import { useAuth } from "../../context/auth";
import "./SwitchAccount.css";

const ROLE_META = {
  guest: {
    title: "Guest",
    description:
      "You'll be able to Attend events, RSVP, and manage invitations",
    icon: "🎟️",
  },
  host: {
    title: "Host",
    description: "You'll be able to  Create and manage events and guests",
    icon: "🎉",
  },
  usher: {
    title: "Usher",
    description: "You'll be able to Check in guests and assist with logistics",
    icon: "🧭",
  },
};

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export default function SwitchAccount({ onSwitched }) {
  const { user, setUser } = useAuth();

  const availableRoles = user.role.filter((role) => role !== user.activeRole);

  const activeRole = user?.activeRole;

  const handleSwitch = (role) => {
    const updatedUser = { ...user, activeRole: role };

    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));

    onSwitched?.();
  };

  if (!availableRoles.length) return null;

  return (
    <div className="switch-account-container1">
      <div className="switch-account-card1">
        <div className="switch-account">
          <h2 className="switch-account-title">
            Switch to {availableRoles.map(capitalize).join(" / ")}
          </h2>

          <p className="switch-account-subtitle">
            You’re currently using a <b>{capitalize(activeRole)}</b> account.
            Select the Account to switch to
          </p>

          <div className="switch-account-card-grid">
            {availableRoles.map((role) => (
              <button
                key={role}
                className="switch-account-role-card"
                onClick={() => handleSwitch(role)}
              >
                <div className="switch-account-icon">
                  {ROLE_META[role].icon}
                </div>

                <div className="switch-account-content">
                  <h4>{ROLE_META[role].title}</h4>
                  <p>{ROLE_META[role].description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
